import { Suspense } from 'react'

import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import {
  EmpreendimentoMidias,
  type MidiaTipo,
} from '@/features/empreendimentos/shared/components/empreendimento-midias'
import { EmpreendimentoMidiasPageSkeleton } from '@/features/empreendimentos/shared/components/empreendimento-midias.skeleton'
import { PageChile as Page } from '@/layouts/page-chile'
import { ApiErrorDisplay } from '@/shared/api-error-display'

type MidiaSelecionada = {
  midiaSelecionada: MidiaTipo
  idExterno: string
}

export const EmpreendimentoMidiasPage = () => {
  const { t } = useTranslation('empreendimentos')
  const { idExterno, midiaSelecionada } = useParams<MidiaSelecionada>()

  const config = {
    titulo: t(`pages.midias.${midiaSelecionada!}.titulo`),
    descricao: t(`pages.midias.${midiaSelecionada!}.descricao`),
  }

  const breadcrumb = [
    { label: t('pages.midias.breadcrumb.empreendimentos'), to: '/es-CL/empreendimentos' },
    { label: t('pages.midias.breadcrumb.detalhes'), to: `/es-CL/empreendimentos/${idExterno}` },
    { label: config.titulo.toUpperCase() },
  ]

  return (
    <Page breadcrumb={breadcrumb}>
      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary FallbackComponent={ApiErrorDisplay} onReset={reset}>
            <Suspense fallback={<EmpreendimentoMidiasPageSkeleton />}>
              <EmpreendimentoMidias config={config} />
            </Suspense>
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </Page>
  )
}
